import React from 'react';
import { useNavigate } from 'react-router-dom';

const Privacidad: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{ fontFamily: "'Segoe UI', system-ui, sans-serif", background: '#f8fafc', minHeight: '100vh' }}>

      <header style={{
        background: '#1f2937', color: 'white', padding: '1.5rem 2rem',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between'
      }}>
        <div>
          <h1 style={{ fontSize: '1.3rem', fontWeight: 700, margin: 0 }}>OmniCrud — ValorPoint</h1>
          <span style={{ fontSize: '0.85rem', color: '#9ca3af' }}>Política de Privacidad</span>
        </div>
        <button
          onClick={() => navigate('/')}
          style={{
            background: '#374151', color: 'white', border: 'none',
            padding: '8px 16px', borderRadius: '6px', cursor: 'pointer', fontSize: '0.9rem'
          }}
        >
          ← Volver
        </button>
      </header>

      <div style={{ maxWidth: '820px', margin: '3rem auto', padding: '0 1.5rem 4rem' }}>

        <div style={{
          display: 'inline-block', background: '#eff6ff', color: '#2563eb',
          fontSize: '0.75rem', fontWeight: 700, padding: '4px 12px',
          borderRadius: '999px', border: '1px solid #bfdbfe', marginBottom: '1.5rem',
          letterSpacing: '0.05em', textTransform: 'uppercase'
        }}>Privacidad</div>

        <h2 style={{ fontSize: '2rem', fontWeight: 800, color: '#0f172a', marginBottom: '0.5rem' }}>
          Política de Privacidad
        </h2>
        <p style={{ color: '#64748b', fontSize: '0.95rem', marginBottom: '2.5rem', borderBottom: '1px solid #e2e8f0', paddingBottom: '1.5rem' }}>
          Última actualización: abril 2026 · ValorPoint · omnicrud.valorpoint.net
        </p>

        <p style={{ color: '#475569', fontSize: '0.95rem', marginBottom: '1rem' }}>
          En <strong>ValorPoint</strong>, nos comprometemos a proteger la privacidad de los usuarios de <strong>OmniCrud</strong>.
          Esta política explica qué información recopilamos, cómo la usamos y cómo la protegemos.
        </p>

        {[
          {
            title: '1. Información que recopilamos',
            content: (
              <>
                <p style={{ color: '#475569', fontSize: '0.95rem' }}>Cuando utilizas OmniCrud, podemos recopilar:</p>
                <ul style={{ color: '#475569', fontSize: '0.95rem', paddingLeft: '1.5rem' }}>
                  <li>Nombre y correo electrónico (al registrarte con Google o Facebook)</li>
                  <li>Foto de perfil pública de tu cuenta de Google o Facebook</li>
                  <li>Identificadores únicos de sesión generados internamente</li>
                  <li>Datos de las tablas y esquemas que creas dentro de la plataforma</li>
                </ul>
              </>
            )
          },
          {
            title: '2. Cómo usamos tu información',
            content: (
              <ul style={{ color: '#475569', fontSize: '0.95rem', paddingLeft: '1.5rem' }}>
                <li>Identificarte como usuario dentro de la plataforma</li>
                <li>Asociar tus proyectos generados a tu sesión</li>
                <li>Mejorar la experiencia de uso de OmniCrud</li>
              </ul>
            )
          },
          {
            title: '3. Inicio de sesión con Google y Facebook',
            content: (
              <>
                <p style={{ color: '#475569', fontSize: '0.95rem' }}>
                  OmniCrud utiliza los servicios de autenticación de Google y Facebook (Meta).
                  Solo solicitamos los permisos mínimos necesarios: nombre, correo electrónico y foto de perfil pública.
                  No accedemos a tus contactos, publicaciones ni ningún otro dato de tu cuenta.
                </p>
              </>
            )
          },
          {
            title: '4. Almacenamiento de datos',
            content: (
              <p style={{ color: '#475569', fontSize: '0.95rem' }}>
                Tus datos se almacenan en servidores seguros administrados por ValorPoint.
                Los proyectos generados se guardan temporalmente y son accesibles únicamente desde tu sesión.
              </p>
            )
          },
          {
            title: '5. Eliminación de datos',
            content: (
              <p style={{ color: '#475569', fontSize: '0.95rem' }}>
                Si deseas eliminar tu cuenta y todos los datos asociados, envía un correo a{' '}
                <strong>contacto@valorpoint.net</strong> con el asunto "Eliminar mis datos".
                Procesaremos tu solicitud en un plazo máximo de 30 días.
              </p>
            )
          },
          {
            title: '6. Cookies',
            content: (
              <p style={{ color: '#475569', fontSize: '0.95rem' }}>
                OmniCrud utiliza <strong>localStorage</strong> del navegador para mantener tu sesión activa y guardar
                preferencias locales. No utilizamos cookies de rastreo ni publicidad.
              </p>
            )
          },
          {
            title: '7. Contacto',
            content: (
              <p style={{ color: '#475569', fontSize: '0.95rem' }}>
                Si tienes preguntas sobre esta política, contáctanos en: <strong>contacto@valorpoint.net</strong>
              </p>
            )
          },
        ].map((section, i) => (
          <div key={i} style={{ marginBottom: '1.5rem' }}>
            <h3 style={{
              fontSize: '1.05rem', fontWeight: 700, color: '#0f172a',
              margin: '2rem 0 0.75rem', display: 'flex', alignItems: 'center', gap: '0.5rem'
            }}>
              <span style={{ display: 'inline-block', width: '4px', height: '18px', background: '#2563eb', borderRadius: '2px' }} />
              {section.title}
            </h3>
            {section.content}
          </div>
        ))}

        <div style={{
          textAlign: 'center', marginTop: '3rem', paddingTop: '1.5rem',
          borderTop: '1px solid #e2e8f0', color: '#94a3b8', fontSize: '0.85rem'
        }}>
          © 2026 <strong style={{ color: '#64748b' }}>ValorPoint</strong> — OmniCrud. Todos los derechos reservados.
        </div>
      </div>
    </div>
  );
};

export default Privacidad;